module.exports = __webpack_public_path__ + "static/primer-button-group-95e7c614381c4eff58f2b7031d1051b2.png";